import { list as _list } from './actions'
import store from '@/store'

/**
 * List of contact type groups
 * @param {Object} requestData
 */
export function list(typeId, requestData) {
  let postId = store.getters['app/account/getPostId']
  return _list(postId, typeId, requestData)
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/api/groups/index.js